import React, { useState } from "react";
import { handlePauseAllVideo, removeStylesFromHtml } from "../../../utils";
import { ReactComponent as ArrowUpIcon } from "../../../Icons/arrowUp.svg";
import { ReactComponent as ArrowDownIcon } from "../../../Icons/arrowDown.svg";
import { ReactComponent as RFUIcon } from "../../../Icons/rfuIcon.svg";
import { ReactComponent as VerifyIcon } from "../../../Icons/verify.svg";
import { ReactComponent as CopyIcon } from "../../../Icons/copy.svg";
import { ReactComponent as ShareIcon } from "../../../Icons/share.svg";
import Rating from "../../Rating/Rating";
import Button2 from "../../Button2/Button2";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import Button from "../../Button/Button";
import { CURRENT_ROLE } from "../../../API/url";
import { rateAnswer } from '../../../API/api';
import { message } from "antd";
import ImgCarousal from "../../Carousal/carousal";

const contentStyle = {
  border: "1px solid #E0E2E6",
  borderRadius: "16px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  width: '100%'
};
export default function Answer({ data, question }) {
  const domainState = useSelector((state) => state.domain.ratings);
  const [messageApi, contextHolder] = message.useMessage();
  const [feedback, setFeedBack] = useState('');
  const randomNumber = Math.random() * 10;
  const editorState = useSelector(state => state.editor);
  const dispatch = useDispatch();
  const { advanceFilterModalToggle, getSelectedQuestion, getSelectedAnswer, getSeekerAttachmentsForAnswered, updateSearchData2 } = bindActionCreators(Actions, dispatch)
  const successfulHelpful = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
  const userState = useSelector((state) => state.user);
  const [permission, setPermission] = useState(userState.roles.find(data => data.roleName === CURRENT_ROLE).permissions.find(item => item.id === 9));
  const [isAccept, setAccept] = useState(null);
  const [isPlay, setPlay] = useState(false);
  const [isShow, setShow] = useState(false);
  const trimString = (str) => {
    if (str.length > 350) {
      return str.slice(0, 350) + "...";
    }
    return str;
  };
  const firstThread = {
    width: "95%",
    minHeight: "44px",
    border: ` 1px solid #E0E2E6`,
    padding: "10px 12px 10px 12px",
    borderRadius: "8px",
    background: "#F6F7F8",
    color: "#2A364A",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "300",
    marginLeft: "5%",
    marginBlock: "5px",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const restThread = {
    width: "85%",
    minHeight: "44px",
    border: "1px solid #E0E2E6",
    padding: "10px 12px 10px 12px",
    borderRadius: "8px",
    background: "#FFFFFF",
    color: "#5C667B",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "300",
    marginLeft: "15%",
    marginBottom: "5px",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const ansStyles = {
    marginTop: "10px",
    fontSize: "15px",
    color: "#5C667B",
    lineHeight: "24px",
    fontWeight: "300",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const showMoreStyles = {
    fontSize: "15px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "500",
    background:
      "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
    backgroundClip: "text",
    "-webkit-text-fill-color": "transparent",
    "-moz-text-fill-color": "transparent",
    "-ms-text-fill-color": "transparent",
    "-o-text-fill-color": "transparent",
    cursor: "pointer",
    marginTop: "5px",
  };
  const onClickVote = (key) => {

  };
  const onClickButton = (key) => {
    // console.log("");
  };
  const onClickShareButton = () => {
    advanceFilterModalToggle({ bool: true, value: "shareQuestion" });
    getSelectedQuestion(question);
  };

  const onClickRFU = () => {
    data.answerText = data.answer;
    question.question = question.text;
    advanceFilterModalToggle({ bool: true, value: "requestForUpdate" });
    getSelectedAnswer(data);
    getSelectedQuestion(question);
  };
  const stripHtml = (htmlString) => {
    return htmlString
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n\n")
      .replace(/<\/?[^>]+(>|$)/g, "");
  }
  const success = () => {
    messageApi.info("hl");
  };
  const onClickCopy = (text) => {
    toast.success(successfulHelpful("Text copied!"), {
      position: toast.POSITION.TOP_RIGHT,
    });
    let newString = stripHtml(data.answer);
    navigator.clipboard.writeText(`${question.text}\n\n${newString}`);

  }
  const onSubmitFeedback = () => {
    const obj = {
      answerUuid: data.answerUuid,
      feedback: feedback,
      rating: domainState[data.docId === undefined ? data.originalAnswerUuid : data.docId].rating
    };
    rateAnswer(
      obj,
      updateSearchData2,
      domainState
    );
  };

  const onClickPlayPause = () => {
    setPlay(!isPlay);
  }
  // console.log("data",data);
  // console.log("ques",question.questionUuid)
  return (
    <>
      {data.attachments && data.attachments.length > 0 && (data.attachments[0].name.toLowerCase().includes('.mp4') || data.attachments[0].name.toLowerCase().includes('.mov')) && (
        <>
          <div className="mt-1" style={{ textAlign: 'right' }}><Button type={'primary'} text={isPlay ? 'Hide Video' : 'Show Video'} onClickFunc={onClickPlayPause} /></div>
          {isPlay && <div className="mb-4 mt-3" style={{ textAlign: 'center' }}>
            <div style={{ width: '100%' }}>
              <video
                id={`${question.questionUuid}_${randomNumber}`}
                controls
                onBlur={() => handlePauseAllVideo()}
                style={contentStyle}
              >
                <source
                  src={`${data.attachments[0].objectUrl}#t=${data.startTime},${data.endTime}`}
                  type="video/mp4"
                />
              </video>
            </div>
          </div>}
        </>
      )}
      {data.attachmentURL && data.attachmentURL.length > 0 && (
        <div className="mb-4 mt-3">
          <div>
            <ImgCarousal data={data.attachmentURL} />
          </div>
        </div>
      )}
      {!data.answer.includes('vizsep') && <div
        style={ansStyles}
        dangerouslySetInnerHTML={{
          __html: !isShow
            ? removeStylesFromHtml(
              trimString(
                data.answer === null
                  ? question.contextData
                  : data.answer
              )
            )
            : removeStylesFromHtml(
              data.answer === null
                ? question.contextData
                : data.answer
            ),
        }}
      ></div>}
      {data.answer.includes('vizsep') && data.answer.split('vizsep').map((thread, index) => {
        return (
          question.reusableThreadQA ? <div style={index === 0 || index === 1 ? firstThread : restThread} dangerouslySetInnerHTML={{ __html: thread }}>
          </div> : <div style={index === 0 ? firstThread : restThread} dangerouslySetInnerHTML={{ __html: thread }}>
          </div>
        )
      })}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "10px",
        }}
      >
        <div>
          {!data.answer.includes('vizsep') && data.answer !== null
            ? data.answer.length > 350 &&
            !isShow && (
              <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                Show more&nbsp;
                <ArrowDownIcon />
              </div>
            )
            : !data.answer.includes('vizsep') && question.contextData.length > 350 &&
            !isShow && (
              <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                Show more&nbsp;
                <ArrowDownIcon />
              </div>
            )}
          {!data.answer.includes('vizsep') && data.answer !== null
            ? data.answer.length > 350 &&
            isShow && (
              <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                Show less&nbsp;
                <ArrowUpIcon />
              </div>
            )
            : !data.answer.includes('vizsep') && question.contextData.length > 350 &&
            isShow && (
              <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                Show less&nbsp;
                <ArrowUpIcon />
              </div>
            )}
        </div>
        {/* {question.docType === "expertqa" && ( */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <Button2 type={"light"} onClickFunc={onClickCopy}>
            <CopyIcon />
          </Button2>
          &nbsp;
          {!question.reusableThreadQA && question.status !== "accepted" && <Button2 type={"light"} onClickFunc={onClickShareButton}>
            <ShareIcon />
          </Button2>}
          {!question.reusableThreadQA && question.status !== "accepted" && permission !== undefined && data.isVerifyShow === undefined && !data.userInitiatedCuration &&
            data.expertUuid !==
            userState.geoAttributes.userId &&
            (data.curationCategory !== 1 ||
              data.curationStatus !== "pending") && <>
              &nbsp;
              <Button2 type={"dark"} onClickFunc={onClickRFU}>
                <RFUIcon />
                &nbsp;Request for update
              </Button2>
            </>}
          {!question.reusableThreadQA && question.status !== "accepted" && permission !== undefined && data.isVerifyShow === undefined && !data.userInitiatedCuration &&
            data.expertUuid !==
            userState.geoAttributes.userId &&
            data.curationCategory === 1 &&
            data.curationStatus === "pending" && <>
              &nbsp;
              <Button2 type={"dark"} onClickFunc={onClickRFU}>
                <RFUIcon />
                &nbsp;Request for update
              </Button2>
            </>}
          &nbsp;
          {
            editorState.ratingBool === false && <Button2 onClickFunc={onClickButton}>
              <Rating id={data.docId === undefined ? data.answerUuid : data.docId} />
            </Button2>
          }

        </div>
        {/* )} */}
      </div>
    </>
  );
}
